export default "__VITE_ASSET__78e1795a__$_?component__"